export default __webpack_public_path__ + "static/media/31.c8f43594.png";